// Turn any request failure into readable text for the alert region (v1.3 ticket 03, RCMC-17).
//
// Replaces the catch block that every screen copy-pasted, which passed the error object itself to
// raiseAlert when the server sent no message (a render crash), and read e.response.status when there
// was no response at all (a second crash).

export const NO_RESPONSE_MESSAGE = "No response from the server — check your connection and try again.";
export const FALLBACK_MESSAGE = "Something went wrong — please try again.";

const isText = (value) => typeof value === "string" && value.trim() !== "";

/**
 * @param {unknown} error  what a `.catch` received: usually an axios error, possibly anything
 * @returns {string} the server's message, else its detail, else the HTTP status, else a no-response text
 */
export function errorMessage(error) {
  const response = error?.response;
  if (!response) {
    // axios sets `request` when the request went out but nothing came back (offline, timeout, reset).
    // Anything else (e.g. a bug thrown inside a .then) gets the generic text, never its own message.
    return error?.request ? NO_RESPONSE_MESSAGE : FALLBACK_MESSAGE;
  }
  if (isText(response.data?.message)) return response.data.message;
  if (isText(response.data?.detail)) return response.data.detail; // DRF auth/throttle errors use `detail`
  return `The request could not be completed (HTTP ${response.status}) — please try again.`;
}
